import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import {createCookiesFromURL} from "@khan/data-cookies";
import {useLocation} from "@khan/urls";

// Parses the query string to set or clear feature flag cookies. We do this
// here instead of in site-infra.ts so we can access growthBook.
export const useFlagsQueryParamToCookie = () => {
    const {queryParams} = useLocation();

    useOnMountEffect(() => {
        createCookiesFromURL(queryParams);
    });
};
